import { Modal, PDFRenderer } from "components";
import { useSearch, useMatch } from "react-location";
import { LocationGenerics } from "router/location";
import { useInsurer } from "hooks/data/use-insurers";
import config from "config";
import { useTreaty, useTreatyEndorsement } from "hooks/data/use-treaties";
import { classNames, wrapClick } from "utils";
import { useState } from "react";
import _ from "lodash";

const internalTabs = [
  {
    name: "Placing Slip",
    href: "PLACING",
  },
  {
    name: "Cover Note",
    href: "COVER",
  },
];

export default function ViewTreatyEndorsementDocumentsContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { params } = useMatch<LocationGenerics>();
  const [orderStatus, setOrderStatus] = useState("PLACING");

  const { loading } = useTreaty({
    treatyId: params.treaty || "",
  });

  const { endorsement } = useTreatyEndorsement({
    filter: {
      treaty_endorsement_id: searchParams?.id || "",
      treatiestreaty_id: params.treaty || "",
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      size="6xl"
      hideActions
      title="Treaty Endorsement Documents"
      description="View the documents related to this treaty endorsement."
    >
      <div className="block">
        <div className="border-b border-background-500 bg-card-500 px-6">
          <nav className="-mb-px flex space-x-8 items-center" aria-label="Tabs">
            {internalTabs.map((_orderStatus) => (
              <button
                key={_orderStatus.name}
                onClick={wrapClick(() => setOrderStatus(_orderStatus.href))}
                className={classNames(
                  orderStatus === _orderStatus.href
                    ? "border-gray-200 text-gray-300"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200",
                  "whitespace-nowrap flex py-4 px-1 border-b-2 font-medium text-sm"
                )}
                aria-current={
                  orderStatus === _orderStatus.href ? "page" : undefined
                }
              >
                {_orderStatus.name}
              </button>
            ))}
          </nav>
        </div>
      </div>
      <PDFRenderer
        url={`${config.asset.uri}generate_endorsement/${btoa(
          JSON.stringify({
            treaty_id: params?.treaty ?? "",
            treaty_endorsement_id: endorsement?.treaty_endorsement_id ?? "",
            end_no: searchParams?.number || "",
            doc_type: _.get(
              internalTabs.find((el) => el.href === orderStatus),
              "href",
              ""
            ),
            title: _.get(
              internalTabs.find((el) => el.href === orderStatus),
              "name",
              ""
            ),
          })
        )}`}
      />
    </Modal>
  );
}
